import React,{useEffect,useRef,useState} from 'react'
import Card from './Card'
import CardComment from './CardComment'
import { modalToggle } from '../../redux/actions/general'
import { useDispatch,useSelector } from 'react-redux'
import SearchRed from 'assets/icon/search-red.png'
import Skeleton from '@material-ui/lab/Skeleton';
import LoadingCard from 'components/LoadingCard'
import LoadingComment from 'components/LoadingComment'
import { postForumAction,getForumDetailBySlug, deleteDiskusi } from 'redux/actions/forum'
import { setPersist } from 'redux/actions/persist'
import { setReducer,setForumList } from 'redux/actions/reducer'
import detectBottom from 'service/detectBottom'
import EmptyBeranda from 'assets/image/empty-beranda.png'
import { useParams } from 'react-router'
import Chevron from 'assets/icon/chevron.png'
import DefaultAva from 'assets/icon/default-ava.jpeg'
const DetailHeaderLoader=()=>(
    <div style={{padding:'20px 20px 20px 20px'}}>
        <div className='div-flex div-justify-between div-align-center'>
            <div className='author-mobile-profile'>
                <Skeleton variant="circle" width={35} height={35} />
                &nbsp;
                <Skeleton variant="text" width={80}/>
            </div>
            <Skeleton variant="text" width={80}/>
        </div>
        <br/>
        <div className='div-flex div-justify-between'>
            <div className='hashtag-section'>
                <Skeleton variant="text" width={100}/>
                <Skeleton variant="text" width={150}/>
                <Skeleton variant="text" width={80}/>
                
            </div>
            <div>
            </div>
        </div>
        </div>
)
export default function Detail(props) {
    
    const dispatch = useDispatch()
    const general = useSelector(state => state.general)
    const reducer = useSelector(state => state.reducer)
    const persist = useSelector(state => state.persist)
    const [page, setpage] = useState(1)
    const [perpage, setperpage] = useState(5)
    const [stop, setstop] = useState(false)
    const [option, setoption] = useState({})
    const [option_comment, setoption_comment] = useState({})

    const ref = useRef()
    // const isVisible = detectBottom(ref)
    const {beranda,forum_detail}=reducer
    const {forum_sort,forum_auth}=persist
    let { id } = useParams();
    let {getDetail}=props
    useEffect(() => {
        
        // if(isVisible&&!stop){
            // setpage(page+1)
            getAsyncDetail()
            // alert('sdf')
        // }
    }, [persist.comment_sort])
    // console.log(`persist.comment_sort`, forum_auth)
    const getAsyncDetail=async ()=>{
        let res=await dispatch(getForumDetailBySlug(`/${persist.comment_sort}/${page}/${perpage}/${id}`))
        if(res){
            // setpage(page+1)
            // if(res.data.items.length>0){
            //     setstop(false)
            // }else{
            //     setstop(true)
            // }
        }
    }
    const sortToggle=(key)=>{
        dispatch(setPersist({comment_sort:key}))
    }
    const addComment=()=>{
        if(forum_auth.canComment){
            dispatch(modalToggle({ 
                modal_open: true,
                modal_title: "Buat Komentar",
                modal_component: "add_comment",
                modal_size:590,
                modal_type:'',
                modal_data:{
                    getAction:()=>getAsyncDetail(),
                    ParentId:forum_detail.id
                },
                modal_action:'add_comment',
            }))
        }
        
    }
    const replyComment=(data)=>{
        if(forum_auth.canComment){
            dispatch(modalToggle({ 
                modal_open: true,
                modal_title: "Balas Komentar",
                modal_component: "reply_comment",
                modal_size:590,
                modal_type:'',
                modal_data:{
                    getAction:()=>getAsyncDetail(),
                    ParentId:data.id
                },
                modal_action:'reply_comment',
            }))
        }
        
    }
    const addSortir=()=>{
        dispatch(modalToggle({ 
            modal_open: true,
            modal_title: "Sortir",
            modal_component: "sortir",
            modal_size:590,
            modal_type:'',
            modal_data:{actionSort:(key)=>sortToggle(key)},
            modal_action:'comment_sort',
        }))
    }
    const showSearch=()=>{
        dispatch(modalToggle({ 
            modal_open: true,
            modal_title: "Cari berdasarkan tag",
            modal_component: "search",
            modal_size:590,
            modal_type:'',
            modal_data:null,
            modal_action:'search',
        }))
    }
    const renderSort=()=>{
        switch (persist.comment_sort) {
            case 1:
                return 'Terbaru'
            case 2:
                return 'Termenarik'
            case 3:
                return 'Terjawab'
            case 4:
                return 'Belum Terjawab'
            default:
                break;
        }
    }
   
    const onClickVote=(data,i)=>{
        if(forum_auth.canVote){
            if(data.level===0){
                forum_detail.nvote=forum_detail.isVoted===false?forum_detail.nvote+1:forum_detail.nvote
                forum_detail.isVoted=true
                dispatch(setReducer({forum_detail:forum_detail}))
                dispatch(postForumAction(`/vote/${data.id}`))
            }
            if(data.level===1){
                forum_detail.child[i].nvote=forum_detail.child[i].isVoted===false?forum_detail.child[i].nvote+1:forum_detail.child[i].isVoted
                forum_detail.child[i].isVoted=true
                dispatch(setReducer({forum_detail:forum_detail}))
                dispatch(postForumAction(`/vote/${data.id}`))
            }
            
        }
        
    }
    const flagAction=(data,i,i2,i3)=>{
        if(data.level===0){
            forum_detail.nflag=forum_detail.nflag+1
            forum_detail.isFlag=true
            dispatch(setReducer({forum_detail:forum_detail}))
            dispatch(postForumAction(`/flag/${data.id}`))
        }
        if(data.level===1){
            forum_detail.child[i].nflag=forum_detail.child[i].nflag+1
            forum_detail.child[i].isFlag=true
            dispatch(setReducer({forum_detail:forum_detail}))
            dispatch(postForumAction(`/flag/${data.id}`))
        }

        if(data.level===2){
            forum_detail.child[i].child[i2].nflag=forum_detail.child[i].child[i2].nflag+1
            forum_detail.child[i].child[i2].isFlag=true
            dispatch(setReducer({forum_detail:forum_detail}))
            dispatch(postForumAction(`/flag/${data.id}`))
        }
        if(data.level===3){
            forum_detail.child[i].child[i2].child[i3].nflag=forum_detail.child[i].child[i2].child[i3].nflag+1
            forum_detail.child[i].child[i2].child[i3].isFlag=true
            dispatch(setReducer({forum_detail:forum_detail}))
            dispatch(postForumAction(`/flag/${data.id}`))
        }
        return data
    }
    const onClickFlag=(data,i,i2,i3)=>{
        if(forum_auth.canFlag){
            dispatch(modalToggle({ 
                modal_open: true,
                modal_title: "",
                modal_component: "delete_diskusi",
                modal_size:400,
                modal_type:'delete',
                modal_data:{
                    actionDelete:()=>flagAction(data,i,i2,i3),
                    getAction:()=>null,
                    data,
                    title:' Laporkan Postingan Ini',
                    desc:'Postingan ini mengandung unsur yang tidak relevan dengan forum diskusi, laporkan postingan ini untuk ditinjau oleh tim kami dan akan dihapus jika memang merupakan postingan yang tidak relevan.',
                    btn_delete:'Laporkan'
                },
                modal_action:'delete_diskusi',
            }))
            
        }
        
    }
    const onClickMark=(data,i,i2,i3)=>{
            if(data.level===1){
                forum_detail.child[i].nMark=forum_detail.child[i].nMark+1
                forum_detail.child[i].isMark=true
                dispatch(setReducer({forum_detail:forum_detail}))
                dispatch(postForumAction(`/mark/${data.id}`))
            }

            if(data.level===2){
                forum_detail.child[i].child[i2].nMark=forum_detail.child[i].child[i2].nMark+1
                forum_detail.child[i].child[i2].isMark=true
                dispatch(setReducer({forum_detail:forum_detail}))
                dispatch(postForumAction(`/mark/${data.id}`))
            }
            if(data.level===3){
                forum_detail.child[i].child[i2].child[i3].nMark=forum_detail.child[i].child[i2].child[i3].nMark+1
                forum_detail.child[i].child[i2].child[i3].isMark=true
                dispatch(setReducer({forum_detail:forum_detail}))
                dispatch(postForumAction(`/mark/${data.id}`))
            }
    }
    const convertHash=(tag)=>{
        let conv=tag.replace('#','%23')
        return conv
    }
    const optionToggle=(data,i)=>{
        setoption({...option,[i]:!option[i]})
    }
    const editDiskusi=(data,i)=>{
        dispatch(modalToggle({ 
            modal_open: true,
            modal_title: "Edit Diskusi",
            modal_component: "add_diskusi",
            modal_size:590,
            modal_type:'',
            modal_data:{getAction:()=>getAsyncDetail(),data},
            modal_action:'edit_diskusi',
        }))
    }
    const actionDeleteDiskusi=async (data)=>{
        let res= await dispatch(deleteDiskusi(data.id))
        if(res){
            dispatch(setReducer({forum_detail:null}))
            return res
        }
    }
    const onDeleteDiskusi=(data,i)=>{
        dispatch(modalToggle({ 
            modal_open: true,
            modal_title: "",
            modal_component: "delete_diskusi",
            modal_size:400,
            modal_type:'delete',
            modal_data:{
                actionDelete:()=>actionDeleteDiskusi(data),
                getAction:()=>getAsyncDetail(),
                data,title:' Hapus Postingan Diskusi',
                desc:'Postingan diskusi mu akan di hapus dari sistem',
                btn_delete:'Hapus Postingan'
            },
            modal_action:'delete_diskusi',
        }))
    }
    const optionCommentToggle=(data,i)=>{
        setoption_comment({...option_comment,[i]:!option_comment[i]})
    }
    const editComment=(data,i)=>{
        dispatch(modalToggle({ 
            modal_open: true,
            modal_title: "Edit Komentar",
            modal_component: "add_comment",
            modal_size:590,
            modal_type:'',
            modal_data:{
                getAction:()=>getAsyncDetail(),
                ParentId:forum_detail.id,
                data
            },
            modal_action:'edit_comment',
        }))
    }
    const deleteComment=(data,i)=>{
        dispatch(modalToggle({ 
            modal_open: true,
            modal_title: "",
            modal_component: "delete_diskusi",
            modal_size:400,
            modal_type:'delete',
            modal_data:{
                actionDelete:()=>dispatch(deleteDiskusi(data.id)),
                getAction:()=>getAsyncDetail(),
                data,
                title:' Hapus Komentar Kamu',
                desc:'Komentar yang kamu pilih akan dihapus',
                btn_delete:'Hapus Komentar'
            },
            modal_action:'delete_comment',
        }))
    }
    return (
        <div>
            
            <div className='author-mobile'>
                {general.isLoadingTable?
                <DetailHeaderLoader/>
                :
                forum_detail!==null&&
                <div style={{padding:'20px 20px 20px 20px'}}>
                <div className='div-flex div-justify-between '>
                    <div className='author-mobile-profile'>
                        <img src={forum_detail.author.profilePic!==''?forum_detail.author.profilePic:DefaultAva}/>
                        <p className='font-roboto margin-0' style={{overflowWrap:"break-word",width:200}}>Dibuat oleh <b>{forum_detail.author.name}</b></p>
                    </div>
                    <p className='font-roboto margin-0' style={{color:'#777777'}}>{forum_detail.lastActivity} </p>
                </div>
                <br/>
                <div className='div-flex div-justify-between'>
                    <div className='hashtag-section'>
                        {forum_detail.tags.map((data,i)=>(
                        <a key={i} href={`/search?q=${convertHash(data)}`}><p  className='hashtag-item font-nunito'>{data}</p></a>

                        ))}
                    </div>
                    <div>
                    <img onClick={showSearch} src={SearchRed} className='search-mobile'/>
                    </div>
                </div>
                </div>}
                <div className='beranda-hr'></div>

            </div>
            {general.isLoadingTable?
                <LoadingCard/>
            :
                forum_detail!==null&&
                    <Card 
                        data={forum_detail}
                        onClickVote={onClickVote}
                        onClickFlag={onClickFlag}
                        forum_auth={forum_auth}
                        optionToggle={optionToggle}
                        option={option}
                        editDiskusi={editDiskusi}
                        deleteDiskusi={onDeleteDiskusi}
                    />
            }
            <br/>
            <div className='detail-header-desktop'>
                <div className='div-flex div-justify-between div-align-center'>
                    <h4 className='font-roboto margin-0'>Komentar </h4>
                    {forum_auth.canComment&&<button onClick={addComment} className='btn-forum'>Buat Komentar</button>}
                </div>
                <div className='beranda-info div-flex div-justify-between div-align-center'>
                    <p className='font-nunito amount-diskusi margin-0'>{forum_detail!==null&&forum_detail.child.length} Komentar</p>
                    <div className='beranda-sort'>
                        <div className={`beranda-sort-item ${persist.comment_sort===1&&'beranda-sort-active'}`} onClick={()=>sortToggle(1)}>
                            <p className='font-nunito margin-0'>Terbaru</p>
                        </div>
                        <div className={`beranda-sort-item ${persist.comment_sort===2&&'beranda-sort-active'}`} onClick={()=>sortToggle(2)}>
                            <p className='font-nunito margin-0'>Termenarik</p>
                        </div>
                    
                    </div>
                </div>
            </div>
            <div className='detail-header-mobile'>
                <div className='div-flex div-justify-between beranda-mobile-head'>
                    <h4 className='font-roboto margin-0'>Komentar</h4>
                    {forum_auth.canComment&&<button onClick={addComment} className='btn-forum'>Buat Komentar</button>}

                </div>
                <div className='div-flex div-justify-between beranda-mobile-info'>
                    <div></div>
                    <div className='div-flex div-align-center' onClick={addSortir}>
                        <p className='font-nunito margin-0'>Sortir : {renderSort()}</p>
                        &nbsp;&nbsp;&nbsp;
                        <img  src={Chevron} className='chevron-mobile-sort'/>
                    </div>
                   
                </div>
            </div>
            <div className='beranda-hr'></div>
            
            {general.isLoadingComment&&
                <>
                    <LoadingComment/>
                    <LoadingComment/>
                </>
            }
            {forum_detail!==null&&forum_detail.child.map((data,i)=>(
                <CardComment 
                    data={data}
                    onClickVote={onClickVote}
                    onClickFlag={onClickFlag}
                    index={i}
                    replyComment={replyComment}
                    onClickMark={onClickMark}
                    forum_auth={forum_auth}
                    key={i}
                    option_comment={option_comment}
                    optionCommentToggle={optionCommentToggle}
                    editComment={editComment}
                    deleteComment={deleteComment}
                />
            ))
            
            }
            {!general.isLoadingComment&&forum_detail!==null&&forum_detail.child.length<1&&
                <div style={{textAlign:'center',height:500}}>
                    <img src={EmptyBeranda} className='empty-beranda'/>
                    <h2 className='font-roboto'>Belum ada komentar{forum_auth.canComment&&<>, ayo <span onClick={addComment} style={{color:'#ff4e4e',cursor:'pointer'}}>Buat Komentar</span></>}</h2>
                </div>
            }
            {/* <div ref={ref}></div> */}

            {general.isLoadingComment&&
                <>
                    <LoadingComment/>
                    <LoadingComment/>
                </>
            }
            <br/><br/>
        </div>
    )
}
